var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.color,"readonly":"","dark":"","outlined":_vm.outlined,"small":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"15"}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n    "+_vm._s(_vm.eventStatus.name)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }